/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wie lange der Vertrag beim Vorversicherer bestand.
 */
export enum JahreBeimVorversicherer {

    NichtBekannt = 'NichtBekannt',

    Bis1Jahr = 'Bis1Jahr',

    Laenger1Jahr = 'Laenger1Jahr',

    Laenger3Jahre = 'Laenger3Jahre',

    Laenger5Jahre = 'Laenger5Jahre'
}

